import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./components/FilterBar/FilterBar.css";
import "./components/Pagination/Pagination.css";
import "./components/BackToTopButton/BackToTopButton.css";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
